import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./hero.module.scss";

export const ElearningLeadHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.heading_wrapper}>
              <h1 className={styles.heading}>
                Band 9 <br /> <span className={"mark color-orange"}>IELTS</span>{" "}
                Speaking Masterclass
              </h1>
              <p className={styles.sub_text}>
                Join us for our two-hour, intensive crash course designed to
                equip you with the skills and strategies you need to score high
                for the IELTS Speaking section!
              </p>

              <div className={styles.btn_wrapper}>
                <a href={"#form"} className={`btn btn-secondary btn-xl`}>
                  Book Now
                </a>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div className="hero_image_wrapper">
              <img
                src="/assets/images/elearning/ielts-band-9-hero.png"
                alt="ielts band 9 hero"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningLeadHero;
